
import DefaultMarkdown from 'react-markdown'
import rehypeSanitize from 'rehype-sanitize'
import rehypeRaw from 'rehype-raw'
import React from 'react'

import CustomCodeBlock from './CustomCodeBlock'
import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material'
import CustomParagraph from './CustomParagraph'
import remarkGfm from 'remark-gfm'
import { EMPTY_OBJECT } from '../../../utils/constants'

const CustomTable = ( { } ) => {
    return (
        <table>
            <thead>
                <tr>
                    <th>Head 1</th>
                    <th>Head 2</th>
                </tr>
            </thead>
        </table>
    )
}

const customComponents = {
    code: CustomCodeBlock,
    table: ( { children, ...props } ) => (
        <TableContainer sx={{ border: t => t.border[1], my: 2, overflowX: 'auto', borderRadius: 5 }}>
            <Table sx={{ minWidth: 650 }} size="small" {...props}>
                {children}
            </Table>
        </TableContainer>
    ),
    thead: ( { children, ...props } ) => <TableHead {...props}>{children}</TableHead>,
    tbody: ( { children, ...props } ) => <TableBody {...props}>{children}</TableBody>,
    tr: ( { children, ...props } ) => <TableRow {...props}>{children}</TableRow>,
    th: ( { children, ...props } ) => (
        <TableCell component="th" sx={{ fontSize: "0.75rem", fontWeight: 'bold', bgcolor: t => t.table.headerBg }} {...props}>
            {children}
        </TableCell>
    ),
    td: ( { children, ...props } ) => <TableCell sx={{ fontSize: "0.75rem" }} {...props}>{children}</TableCell>
}

export default function Markdown ( { components = EMPTY_OBJECT, children, styles = EMPTY_OBJECT } ) {
    return (
        <Typography
            sx={{ flexGrow: 1, fontSize: "0.75rem", overflow: "auto", p: "1px", ...styles }}
            className="markdown-content"
            component="div"
        >
            <DefaultMarkdown rehypePlugins={[rehypeRaw, rehypeSanitize]} remarkPlugins={[remarkGfm]} components={{ ...customComponents, ...components }}>
                {children}
            </DefaultMarkdown>
        </Typography>
    )
}
